import http from '../http'
import { uploadEt } from '@/utils'

export default {
  // 添加/更新货品
  addUpdate(data: object, options?: object) {
    return http
      .post('/order/shopping_cart/product/add_update', data, options)
      .then((res: any) => {
        // 埋点，货品加购次数（因为加购的地方太多了，统一在这里处理比较好）
        const {
          saleProduct: { productId, details },
        } = res.data

        const sku_id = details
          .map((item: any) => item.skuId)
          .filter((item: any) => !!item)

        uploadEt({
          event_type: 6,
          products: [
            { product_id: productId, ...(sku_id.length && { sku_id }) },
          ],
        })

        return res
      })
  },
  // 删除货品
  deleteProd(data: object) {
    return http.post('/order/shopping_cart/product/delete', data)
  },
  // 查询购物车商品
  queryCartProduct(data: object) {
    return http.post('/order/shopping_cart/product/query_list', data)
  },
  // 查询购物车信息（不含购物车商品）
  getCartInfo(data: object) {
    return http.post('/order/shopping_cart/query', data)
  },
  // 更新购物车信息排序等
  shoppingCartUpdate(data: object) {
    return http.post('/order/shopping_cart/update', data)
  },
  // 清空购物车
  shoppingCartReset(data: object) {
    return http.post('/order/shopping_cart/reset', data)
  },
  // 购物车确认订单
  shoppingCartCheckout(data: object) {
    return http.post('/order/pai_fa/shopping_cart/checkout', data)
  },
  // 刷新货品冲突
  shoppingCartProductRefresh(data: object) {
    return http.post('/order/shopping_cart/product/refresh', {
      ...data,
      interfaceVersion: 1,
    })
  },
  // 购物车单个查询
  shoppingCartProductQuery(data: object) {
    return http.post('/order/shopping_cart/product/query', data)
  },
  // 校验购物车货品冲突，进店、下单、结账 3 个地方调用
  shoppingCartValidateWholeCart(data: object, config?: object) {
    return http.post('/order/shopping_cart/validate_whole_cart', data, config)
  },
  // 一键清除冲突货品
  clearConflictProduct(data: object) {
    return http.post(
      '/order/pai_fa/shopping_cart/product/clear_all_conflict',
      data,
    )
  },
  // 全选购物车
  shoppingCartSelectAll(data: object) {
    return http.post('/order/pai_fa/shopping_cart/product/select_all', data)
  },

  // 订单
  // 查询销售单列表
  useQueryOrderList(data: object) {
    return http.usePost('/order/sale_order/query_list', data)
  },
  // 单据单个查询
  saleOrderQuery(data: object) {
    return http.post('/order/sale_order/query', data)
  },
  // 单据货品列表查询
  useQueryOrderProductList(data: object) {
    return http.usePost('/order/sale_order/product/query_list', data)
  },
  // 单据货品列表查询
  queryOrderProductList(data: object) {
    return http.post('/order/sale_order/product/query_list', data)
  },
  // 获取单据图单
  saleOrderQueryElectronicBill(data: object) {
    return http.post('/order/sale_order/query/electronic_bill', data)
  },
  // 下单
  orderAdd(data: object) {
    return http.post('/order/pai_fa/order/add', data)
  },
  // 再次下单
  orderCopy(data: object) {
    return http.post('/order/pai_fa/order/copy_order', data)
  },
  // 获取支付签名串
  signInfo(data: object) {
    return http.post('/order/sale_order/pay/sign_info', data)
  },
  // 支付解锁
  cancelCash(data: object) {
    return http.post('/order/sale_order/cloud/cancel_cash', data)
  },
  // 更新订单备注
  updateRemark(data: object) {
    return http.post('/order/sale_order/update_remark', data)
  },
  /* 删除订单浏览记录 */
  order_record_delete(data: object) {
    return http.post('/order/sale_order/delete/scan_order_record', data)
  },
  /* 抄单 */
  saleOrderCopy(data: object) {
    return http.post('/order/sale_order/copy_order', data)
  },
  /* 检查可否编辑单 */
  editValidation(data: object) {
    return http.post('/order/sale_order/validate_can_edit', data)
  },
  /* 发起修改销售单 */
  startEdit(data: object) {
    return http.post('/order/sale_order/start_edit', data)
  },
  /* 增加订单浏览记录 */
  addScanOrderRecord(data: object) {
    return http.post('/order/sale_order/add/scan_order_record', data)
  },
  // 查询销售单物流列表
  orderExpressListQuery(data: object) {
    return http.post('/order/express/query_order_express', data)
  },
  // 查询销售单物流详情
  orderExpressDetailQuery(data: object) {
    return http.post('/order/express/query_express', data)
  },
  /* 删除订单浏览记录 */
  orderRecordDelete(data: object) {
    return http.post('/order/sale_order/delete/scan_order_record', data)
  },
  /**
   * [getStatementOrder 获取对账单列表]
   * @param  {[type]} data [description]
   * @return {[type]}      [description]
   */
  getStatementOrder(data: object) {
    return http.post('/kp-server-saleorder/statement_order/query', data)
  },
  /**
   * [getStatementOrderSign 获取对账单支付签名串]
   * @param  {[type]} data [description]
   * @return {[type]}      [description]
   */
  getStatementOrderSign(data: object) {
    return http.post('/kp-server-saleorder/statement_order/pay/sign_info', data)
  },
  /**
   * [getStatementOrderStatement 查询对账单支付状态]
   * @param  {[type]} data [description]
   * @return {[type]}      [description]
   */
  getStatementOrderStatement(data: object) {
    return http.post(
      '/kp-server-saleorder/statement_order/query_statement',
      data,
    )
  },
  /**
   * 对账单支付去锁
   *
   * @param {*} data
   * @returns
   */
  removeCashLock(data: object) {
    return http.post(
      '/kp-server-saleorder/statement_order/pay/remove_cash_lock',
      data,
    )
  },
  // 作废销售单
  obsoleteSaleOrder(data: object) {
    return http.post('/kp-server-saleorder/sale_order/obsolete', data)
  },
  // 查询物流列表
  queryLogisticsList(data: object) {
    return http.post('/order/pai_fa/config/logistics/query_by_page', data)
  },
  // 查询退货单详情
  queryReturnDetail(data: object) {
    return http.post('/order/return_order/order/query', data)
  },
  // 查询退货单货品列表
  queryReturnProductList(data: object) {
    return http.post('/order/return_order/order_product/query_by_page', data)
  },
  // 查询订单统计
  getOrderCountStats(data: object, option: object = {}) {
    return http.post('/order/sale_order/count/stats', data, option)
  },
}
